import React from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useOcGenders } from "oc/hooks";

interface GenderSelectorProps {
  name: string;
  value: { code: string };
  label: string;
  onChange: (name: string, gender: { code: string; name: string }) => void;
}

export const OcFormEditorGenderSelector: React.FC<GenderSelectorProps> = ({
  name,
  value,
  label,
  onChange,
}) => {
  const { t } = useTranslation();
  const { data: genders = [] } = useOcGenders();

  type OcGender = { code: string; name: string };

  const getGender = (code: string) =>
    (genders as OcGender[]).find((item) => item.code === code);

  return (
    <Box paddingTop="36px">
      <FormControl
        id={"gender-form-control"}
        variant="outlined"
        style={{
          height: "56px",
          width: "100%",
        }}
      >
        <InputLabel htmlFor={"gender-select"}>{t(label)}</InputLabel>
        <Select
          id={name}
          name={name}
          value={genders.length > 0 ? (value.code || "") : ""}
          label={t(label)}
          defaultValue=""
          onChange={(e) =>
            onChange(name, getGender(e.target.value) || { code: "", name: "" })
          }
        >
          {genders.map((item: OcGender, code: number) => (
            <MenuItem key={`${item}-${code}`} id={`${code}`} value={item?.code}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default OcFormEditorGenderSelector;
